import { render, staticRenderFns } from "./sms_marketing_effect.vue?vue&type=template&id=d6c2c31a&scoped=true"
import script from "./sms_marketing_effect.vue?vue&type=script&lang=js"
export * from "./sms_marketing_effect.vue?vue&type=script&lang=js"
import style0 from "./sms_marketing_effect.vue?vue&type=style&index=0&id=d6c2c31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c2c31a",
  null
  
)

export default component.exports